import CoreAPIService from '../../../utils/core-api';
import { fetchAction } from '../../actions';
import { PromoById } from '../api-types';

export const name: string = 'marketing';

export const types = {
    GET_PROMO: name + '/GET_PROMO',
    EDIT_PROMO: name + '/EDIT_PROMO',
    SAVE_PROMO: name + '/SAVE_PROMO',
};

interface MarketingState {
    promos: PromoById;
}

const initialState: MarketingState = {
    promos: {},
};

const reducer = (state = initialState, action): MarketingState => {
    const payload = action.payload;
    const parameters = action.parameters;
    const id = parameters ? parameters.id : 0;
    switch (action.type) {
        case types.GET_PROMO:
        case types.EDIT_PROMO:
        case types.SAVE_PROMO:
            return {
                ...state,
                promos: { ...state.promos, [id]: { ...state.promos[id], ...payload } },
            };
        default:
            return state;
    }
};
export default reducer;

export const actions = {
    getPromo: (id) => fetchAction(CoreAPIService.get(`/core/promotions/${id}`), types.GET_PROMO, { id }),
    editPromo: (id, payload) =>
        fetchAction(CoreAPIService.put(`/core/promotions/${id}`, payload), types.EDIT_PROMO, { id }),
    savePromo: (id, payload) =>
        fetchAction(CoreAPIService.post(`/core/promotions/${id}`, payload), types.SAVE_PROMO, { id }),
};

const localState = (state: any): MarketingState => state[name] || initialState;
export const selectors = {
    promos: (state) => localState(state).promos || {},
};
